import { registerActions } from '@/lib/actions';
import { registerCommands, registerView } from '@/lib/slots';
import type { ClientArea } from '../types';
import { openFollowupDialog } from './FollowupDialog';

// Home (the day at a glance), Activity this week, the Bin and the follow-up dialog.
export const area: ClientArea = {
  name: 'home',
  setup() {
    registerView('today', () => import('./HomeView'));
    registerView('activity', () => import('./ActivityView'));
    registerView('bin', () => import('./BinView'));
    registerActions({ addFollowup: (init) => openFollowupDialog(init) });
    registerCommands(() => [
      {
        id: 'add-followup',
        title: 'Add a follow-up',
        sub: 'A reminder for you or a teammate',
        icon: 'clock',
        keywords: 'reminder task todo follow up',
        order: 97,
        run: () => openFollowupDialog(),
      },
    ]);
  },
};
